import type { RestoreJob } from '@repo/api-gw-sdk';

import {
  backupRegion,
  initiatorId,
  jobId,
  jobResourceName,
  resourceId,
  resourceType,
  restoreAccount,
  restoreRegion,
  partialRestoreData,
  vault,
  queryResults,
} from '@/components/queryBuilder/properties';
import type { FilterProperty } from '@/types/advanceFilter';

export const restoreJobItemFields = [
  jobId,
  jobResourceName,
  resourceType,
  resourceId,
  initiatorId,
  partialRestoreData,
] as FilterProperty<RestoreJob>[];

export const restoreJobSummaryFromFields = [
  vault,
  backupRegion,
] as FilterProperty<RestoreJob>[];

export const restoreJobSummaryToFields = [
  restoreAccount,
  restoreRegion,
  queryResults,
] as FilterProperty<RestoreJob>[];
